import axios from "axios";
import Router from '../router'

export const http = (options) => {
    // 初始化options。默认post请求。自己去取token
    if(['get','GET','DELETE','delete'].includes(options.method)) {
        options.params = Object.assign(options.data || {});
        delete options.data;
    } else  if(!options.method) {
        options.method = 'post';
    }
    options.headers = {
        token: localStorage.getItem('token')
    }
    return new Promise((resolve, reject) => {
        axios(options).then(res => {
            if (res.status === 200) {
                let result = res.data;
                // 401token无效或者没有token
                if(result.code === 200) {
                    resolve(result.data)
                } else if (result.code === 401) {
                    localStorage.clear();
                    reject(result.message + '：token无效/token已过期');
                    this.$message.error(result.message + '：token无效/token已过期');
                    // hash模式下要引入router对象进行内部跳转
                    Router.push({ name: 'login' })
                    // location.href = '/login';
                } else if(result.code === 500) {
                    reject(result.message + '服务器故障');
                    this.$message.error(result.message + '服务器故障');
                } else {
                    reject(result.message);
                    this.$message.error(result.message);
                }
            } else {
                reject(res.status);
                this.$message.error(result.status);
            }
        }).catch(err => {
            reject(err);
            this.$message.error(err);
        });
    });
};



// WEBPACK FOOTER //
// ./src/utils/http.js